<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.svg" alt="讯图科技">
    </div>
    <p class="title">扬州讯图网络科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：江苏省扬州市科技园</span>
      <span>Tel：0755-88888888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：contact@xun-tu.com</span>
      <span>微信号：xuntukj</span>
    </p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }} 扬州讯图网络科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 100px;
  height: auto;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue